<template>
  <a class="custom-button" :class="[`${disabled ? 'is-disabled' : ''}`]" @click="handleClick">
    <button class="button"
      :class="[`button-${type}`, `${plain ? 'is-plain' : ''}`, `${loading ? 'is-loading' : ''}`, `${disabled ? 'is-disabled' : ''}`, `${light ? 'is-light' : ''}`]">
      <slot name="loading" v-if="loading">
        <loading-svg></loading-svg>
      </slot>
      <slot></slot>
    </button>
  </a>
</template>

<script>
import LoadingSvg from "@/components/loadingSvg";
export default {
  components: { LoadingSvg },
  props: {
    type: {
      type: String,
      default: ""
    },
    plain: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {

  },
  methods: {
    handleClick(event) {
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
